import { date, money0 } from "@keel/core";
import { Stat } from "@keel/ui";

/** Home dashboard: instalments in the next 30 days. */
export function LoansTile({
  data,
}: {
  data: {
    agreements: number;
    outstanding: number;
    due30: number;
    overdue: number;
    next: { date: string; number: string } | null;
  };
}) {
  return (
    <Stat
      label="Loan payments · 30 days"
      value={money0(data.due30)}
      href="/loans"
      tone={data.overdue ? "danger" : undefined}
      foot={
        data.overdue
          ? `${money0(data.overdue)} overdue`
          : data.next
            ? `Next ${date(data.next.date)} · ${money0(data.outstanding)} owed`
            : `${money0(data.outstanding)} owed`
      }
    />
  );
}
